<template>
  <div class="tw-bg-highlight-background-weak tw-border-border tw-border-b tw-py-2 tw-px-4">
    <div class="tw-flex tw-items-start md:tw-items-center">
      <div
        class="tw-flex tw-flex-col md:tw-flex-row tw-flex-1 tw-justify-center tw-items-center nx-text-body3"
      >
        <font-awesome-icon
          icon="fa-regular fa-bullhorn"
          class="tw-hidden md:tw-block tw-text-highlight-icon tw-text-[16px] tw-me-2"
        />
        <div>
          <span class="tw-font-bold tw-me-2">Announcement</span>Nexcess and Liquid Web are becoming
          one brand.
        </div>
        <a
          class="tw-py-1 md:tw-py-0 tw-ms-0 md:tw-ms-4 tw-underline"
          :href="NX_BECOMING_LW_LINK"
          target="_blank"
        >
          Learn more
        </a>
      </div>
      <IconButton
        @click="dismissNxBecomingLwBanner"
        :icon="{
          default: { icon: 'fa-regular fa-xmark' },
          hover: { icon: 'fa-solid fa-xmark' },
        }"
        class="tw-text-[16px]"
      />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import constants from "@/utils/constants";
import IconButton from "@/components/display/IconButton.vue";
import store from "@/store";

export default {
  name: "NxBecomingLwBanner",
  components: {
    IconButton,
  },
  setup() {
    const client = computed(() => store.state.auth.client);

    const dismissNxBecomingLwBanner = () => store.dispatch("nxToLw/set", client.value.id);

    return {
      dismissNxBecomingLwBanner,
      NX_BECOMING_LW_LINK: constants.LINKS.NEXCESS.BLOG.NX_BECOMING_LW,
    };
  },
};
</script>
